import { Table } from 'antd';
import { billListSelectors } from 'containers/App/selectors';
import { getDataPSG } from 'pages/ListBilling/thunk';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t_billing_process } from 'types';

type Props = {
  bill: t_billing_process;
  loadData: boolean;
  setLoadData: any;
};

const TablePSG: FC<Props> = ({ bill, loadData, setLoadData }) => {
  const dispatch = useDispatch();
  const { detailPSG } = useSelector(billListSelectors);

  useEffect(() => {
    (async () => {
      if (loadData) {
        const result: any = await dispatch(getDataPSG({ invoice_id: bill.invoice_id }));
        if (result.payload) {
          setLoadData(false);
        }
      }
    })();
  }, [bill.invoice_id, dispatch, loadData, setLoadData]);

  const columns: any = useMemo(() => {
    return [
      {
        title: 'No.',
        dataIndex: 'no',
        key: 'no',
        width: '5%',
        align: 'center',
        render(text: string, row: any, index: number) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{index + 1}</div>,
          };
        },
      },
      {
        title: 'ご利用者名',
        dataIndex: 'name',
        key: 'name',
        width: '25%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: 'CPAP請求月',
        key: 'inspection_day',
        dataIndex: 'inspection_day',
        width: '15%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text ? `${text.slice(0, 4)}年${Number(text.slice(4))}月` : ''}</div>,
          };
        },
      },
      {
        title: '備考',
        key: 'psg_remark',
        dataIndex: 'psg_remark',
        width: '40%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', paddingLeft: '10px' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];
  }, []);

  return (
    <div>
      <Table columns={columns} dataSource={detailPSG ?? []} pagination={false} />
    </div>
  );
};

export default TablePSG;
